import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/SalesAttributionDrilldownChart';
import { renderTitle } from './getSalesAttributionColumns';
import { formatNumWithKMB, formatNumWithKMBAlt } from './helperMethods';
import _ from 'lodash';
import { Tooltip } from 'antd';

//price ladder table columns
export const getPriceCurveTableColumns = (
    data: any,
    width: number,
    label: string,
    decimalForNonPercentage: number,
    decimalForPercentage: number,
): any => {
    let result = [];
    const keys = data && data.length > 0 ? Object.keys(data?.[0]) : [];
    const columns =
        data && data.length > 0
            ? keys.map((item: any, index: number) => {
                  return {
                      title:
                          index === 0
                              ? ''
                              : renderTitle(
                                    item === 'xAxis' ? label : item,
                                    undefined,
                                    undefined,
                                    'text-purpleFont !font-bold',
                                    graphXAxisLabelFontSize,
                                ),
                      //title: index > 1 ? renderTitle(item) : '',
                      dataIndex: item,
                      key: item,
                      align: index === 0 ? 'left' : 'center',
                      fixed: index === 0 ? 'left' : null,
                      width: [0, 1].includes(index) ? 150 : width,
                      render: (columnData: any, rowData: any, idx: number) => {
                          const isString = typeof columnData === 'string';
                          //show tooltip for 1st column
                          if (index === 0) {
                              const labelMapping: any = {
                                  YA: 'Year Ago',
                              };

                              const tooltipContent = `${
                                  labelMapping?.[columnData?.slice(-2)] ?? ''
                              } ${columnData?.slice(0, -2)}`;
                              return (
                                  <Tooltip destroyTooltipOnHide trigger={'hover'} title={tooltipContent}>
                                      <div className={`font-xs font-medium`}>{columnData}</div>
                                  </Tooltip>
                              );
                          }
                          return (
                              <div className={`font-xs ${isString ? 'font-medium' : ''}`}>
                                  {_.isNull(columnData?.value)
                                      ? ''
                                      : isString
                                      ? columnData
                                      : columnData?.pre +
                                        formatNumWithKMBAlt(
                                            columnData?.value,
                                            columnData?.post === '%' ? decimalForPercentage : decimalForNonPercentage,
                                            columnData?.post === '%' ? undefined : decimalForNonPercentage,
                                        ) +
                                        columnData?.post}
                              </div>
                          );
                      },
                      //   render:(columnData:any,rowData:any) =>{
                      //     return (

                      //     )
                      //   }
                  };
              })
            : [];

    result = [...columns];
    return result;
};
